import React, { ReactElement, useEffect, useRef, useState } from 'react';
import {
  Form, Table, Pagination, Button, Select,
  Row, Col, Skeleton, Empty, Tooltip, Checkbox,
} from 'antd';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { useHistory } from 'react-router-dom';
import {
  ALL,
  INPATIENT_ACTIONS,
  PRIMARY_BUTTON_TYPE,
  renderIPOptions,
  SEARCH_PLACEHOLDER,
  TABLE_SIZE_MIDDLE,
} from '../../../../shared/constants/crmConstants';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../store';
import {
  setFilterAction, fetchInPatientList,
  searchInPatientList, setSortingPreference, setPageIndex,
  clearSearchDetail, saveInPatientConfig, nextStatusAction, setCountClicked, setBulkUploadSelectedClaims, setUpdateCourierDetailClicked,
  setIsDraftBtnClicked,
} from '../../../../store/actions/inPatientAction';
import { setSideBarHeader } from '../../../../store/actions/leftSideBarAction';
import { base64UrlEncode, centeredNotification, canActivate } from '../../../../utils/utility';
import { authFeatureConstants, GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import {
  checkIfAnyTableSearchEnabled, getIsPageNameDetail, getTableBasedOnConfig,
} from '../../../crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import TableConfigurator from '../../../../shared/components/TableConfigurator/TableConfigurator';
import { FormInstance } from 'antd/lib/form';
import { FilterOutlined } from '@ant-design/icons';
import '../../../crm/inPatient/list/floatLabel.less';
import FilterAutoComplete from '../../../../shared/components/FilterAutocomplete/FilterAutoComplete';
import {
  fetchInPatientInsurerList, fetchInpatientStatusList,
} from '../../../../store/actions/lookUpAction';
import { getReimbursementTableMapping } from '../../../../shared/constants/reimbursementConstants';
import './List.less';
import { isEmpty } from 'lodash';
import { PayerInitialState } from '../../../../store/models/payerListModel';
const List = (props: any): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [claimForm] = Form.useForm();

  const mounted = useRef(false);
  const [inPatientData, setInPatientData] = useState([] as any);
  const { Option } = Select;
  const [inPatientDataCount, setInPatientDataCount] = useState(-1);
  const [draftDataCount, setDraftDataCount] = useState(-1);
  const [inPatientColumns, setInPatientColumns] = useState([] as any);
  const [isColumnFilter, setIsColumnFilter] = useState(false);
  const [isTblLoading, setIsTblLoading] = useState(false);

  const {
    lookUp: { payerClaimStatuses = [], allInsurers = [] },
    util: { oldLocations = [] },
  } = useSelector((state: RootState): any => state || {});
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const {
    isNextStatus, tpaNextStatus, timeFilter, tpaSecondaryFilter,
    bulkUploadSelectedClaims, updateCourierDetailClicked,
    filterAction, isSearchClicked, pageIndex, filters, sortingKey,
    isDraftBtnClicked, isGlobalFilter,
  } = useSelector((state: RootState): any => state?.selectedInPatientDetail || {});
  const { allPayers } = useSelector((state: RootState): PayerInitialState => state.payerList);
  claimForm.setFieldsValue(bulkUploadSelectedClaims);
  const [searchForm] = Form.useForm();
  const autoCompleteRef = React.createRef<any>();
  const inPatientTableMapping = getReimbursementTableMapping(canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS));
  const [resetBtnType, setResetBtnType] = useState<any>('default');

  useEffect((): any => {
    dispatch(setSideBarHeader(ALL));
    mounted.current = true;
    if (!payerClaimStatuses || payerClaimStatuses.length === 0) {
      dispatch(fetchInpatientStatusList());
    }
    if (isEmpty(allInsurers) && !isEmpty(allPayers) ) { // to prevent insurer call as there is no active payer
      dispatch(fetchInPatientInsurerList());
    }
    if (oldLocations[0] && !getIsPageNameDetail(oldLocations[0])) {
      dispatch(clearSearchDetail());
      }
    return (): boolean => {
      if (oldLocations[0] && !getIsPageNameDetail(oldLocations[0])) {
        dispatch(clearSearchDetail());
      }
      dispatch(nextStatusAction(false));
      return mounted.current = false;
    };
  }, []);

  useEffect((): any => {
    if (checkIfAnyTableSearchEnabled(filters, sortingKey)) {
      setIsColumnFilter(true);
    } else {
      setIsColumnFilter(false);
    }
  }, [filters, sortingKey]);

  useEffect((): any => {
    setLoaderStateValue();
    setIsTblLoading(true);
    dispatch(fetchInPatientList({
      getInPatientList, isReimbursement: true,
    }));
  }, [isSearchClicked]);

  useEffect((): any => {
    const filteredTable = getTableBasedOnConfig(isPreAuthClaimViewEnabled ?
     appDetail.getIPPreAuthViewConfig() : appDetail.getIPConfig(), inPatientTableMapping);
    setInPatientColumns([...filteredTable]);
  }, [appDetail]);

  useEffect((): any => {
    setResetBtnType(
      (
        isNextStatus || isColumnFilter || isGlobalFilter || filterAction !== ALL ||
        tpaNextStatus || timeFilter || tpaSecondaryFilter
      ) ? 'primary' : 'default',
    );
  }, [isColumnFilter, isNextStatus, filterAction, isGlobalFilter, tpaNextStatus, timeFilter, tpaSecondaryFilter]);

  const setLoaderStateValue = (): void => {
    setInPatientDataCount(-1);
    setInPatientData(null);
    if (draftDataCount > 0) {
      setDraftDataCount(-1);
    }
  };
  const pageChange = (pageNumber: any): any => {
    dispatch(setPageIndex(pageNumber));
    dispatch(searchInPatientList());
  };

  const changeAction = (selectedActionValue: any): void => {
    setLoaderStateValue();
    if (!selectedActionValue) {
      selectedActionValue = ALL;
    }
    dispatch(setFilterAction(selectedActionValue));
    dispatch(setPageIndex(1));
    dispatch(setSideBarHeader(selectedActionValue));
    dispatch(searchInPatientList());
    dispatch(nextStatusAction(false));
  };

  const getInPatientList = (data: any): void => {
    const { claimDetails, count, isSuccess, errors = [] } = data;
    if (isSuccess && mounted.current) {
      claimDetails.map((detail: any, index: number): void => {
        detail.key = index;
      });
      setInPatientData(claimDetails);
      setInPatientDataCount(count);
    } else {
      setInPatientData([]);
      setInPatientDataCount(count);
      centeredNotification(errors.join(',\n'));
    }
    setIsTblLoading(false);
  };

  const rowClick = (event: any, record: any, rowIndex: any): any => {
    const { hospActionId, payerClaimNo, payerId, productCode } = record || {};
    const dataToOpenDetail = { hospActionId, payerClaimNo, payerId, productCode };
    history.push(`/reimbursement/home/detail/${base64UrlEncode(JSON.stringify(dataToOpenDetail))}`);
  };

  const newAdmissionRoute = (): void => {
    history.push('/reimbursement/home/new-admission');
  };
  const blankArr = Array(10).fill(0);

  const handleTableChange = (...attributes: any): any => {
    const { columnKey: key, order: value } = attributes[2];
    const columnToUpdate = inPatientColumns.find(({ key: colKey }: any): boolean => colKey === key);
    if (value !== undefined) {
    columnToUpdate.sortOrder = value;
    setInPatientColumns([...inPatientColumns]);
    dispatch(setSortingPreference(value ? { key, value: String(value).toUpperCase() } : null));
    }
    dispatch(searchInPatientList());
  };

  const onColumnEditSave = (form: FormInstance, setIsVisible: any): any => {
    dispatch(saveInPatientConfig(form.getFieldsValue(), setIsVisible, 'inPatient'));
  };

  const resetFilter = (): any => {
    const updatedInPatientList =
      inPatientColumns
        .filter((ic: any): any =>
          ic?.key !== 'selected',
        )
        .map((ele: any): any => {
          ele.sortOrder = false;
          return ele;
        });
    claimForm.resetFields();
    dispatch(setIsDraftBtnClicked(false));
    setInPatientColumns([...updatedInPatientList]);
    searchForm.setFieldsValue({ searchValue: '' });
    autoCompleteRef?.current?.setSearchPlaceholder(SEARCH_PLACEHOLDER);
    autoCompleteRef?.current?.setFilterOptions([]);
    dispatch(clearSearchDetail());
    dispatch(setCountClicked(true));

    if (updateCourierDetailClicked) {
      setIsTblLoading(true);
      dispatch(fetchInPatientList({
        getInPatientList,
      }));
      dispatch(setUpdateCourierDetailClicked(false));
    }
  };

  const getSelectedClaims = (): any => {
    const claimFormData = claimForm.getFieldsValue(true) || {};
    return Object.keys(claimFormData)
      ?.filter(
        (k: any): any =>
        claimFormData[k],
      );
  };

  const getCheckBoxColumn = (selectedClaimCount: number): any => {
    return {
        title: <div className="circle">{selectedClaimCount}</div>,
        dataIndex: 'selected',
        key: 'selected',
        className: 'text-elipsis',
        render: (text: any, row: any): any => (
          <div onClick={selectedClickHandler}>
            <Form.Item
              name={`${row.hospActionId}_${row.payerId}_${row.productCode}`}
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </div>
        ),
       };
     };

  const setCheckBoxColumnInTable = (selectedClaimCount: number): void => {
    const filteredTable = getTableBasedOnConfig(appDetail.getIPConfig(), inPatientTableMapping);
    const updatedColumns: any = [
      getCheckBoxColumn(selectedClaimCount),
      ...filteredTable,
        {
         key: 'action',
         render: renderIPOptions,
        },
    ];
    setInPatientColumns(updatedColumns);
  };

  const selectedClickHandler = (e: any): any => {
    e.preventDefault();
    e.stopPropagation();

    setTimeout((): void => {
      const selectedClaims = getSelectedClaims();
      setCheckBoxColumnInTable(selectedClaims?.length);
    }, 0);
  };

  const fieldsChangeHandler = (data: any): any => {
    const claimFormData = claimForm.getFieldsValue(true) || {};
    dispatch(setBulkUploadSelectedClaims(claimFormData));
  };

  return <>
    <PageHeader
      pageTitle="Reimbursements"
      customeClass="mt-lg"
      rightComponent={
        (): ReactElement =>
          <Form
            form={searchForm}>
            <Row gutter={GUTTOR_SPACE} justify="end">
              <Col md={6}>
                <Select
                  className="w-100"
                  data-testid="inpatient-filter"
                  showSearch={true}
                  placeholder="Status"
                  optionFilterProp="children"
                  defaultValue={filterAction}
                  onChange={changeAction}
                  filterOption={(input: any, option: any): any =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {
                    INPATIENT_ACTIONS.map((actionVal: string, index: number): any =>
                      <Option value={actionVal} key={index} data-testid={'status-' + actionVal}>{actionVal}</Option>)
                  }
                </Select>
              </Col>
              <Col md={6}>
                <FilterAutoComplete
                  setLoaderStateValue={setLoaderStateValue}
                  ref={autoCompleteRef}
                  form={searchForm} />
              </Col>
              <Col>
                <Tooltip title="Reset filter" mouseEnterDelay={0.25}>
                  <Button
                    data-testid="clear-filter"
                    onClick={resetFilter}
                    type={resetBtnType}
                    icon={<FilterOutlined />}
                  />
                </Tooltip>
              </Col>
              <Col>
                <TableConfigurator
                  tableMapping={inPatientTableMapping}
                  saveClickHandler={onColumnEditSave}
                  configuration={isPreAuthClaimViewEnabled ? appDetail.getIPPreAuthViewConfig() : appDetail.getIPConfig()} />
              </Col>
              {
                <Col>
                  <Form.Item>
                    <Button
                      type={PRIMARY_BUTTON_TYPE}
                      data-testid="new-admission"
                      onClick={newAdmissionRoute}
                    >
                      New admission
                    </Button>
                  </Form.Item>
                </Col>
              }
            </Row>
          </Form>}
    />

    <div className="ant-tabs-content-holder tab-custom-container">
      <Form
        form={claimForm}
        onFieldsChange={fieldsChangeHandler}
      >
        <Table
          data-testid="in-patient-list"
          size={TABLE_SIZE_MIDDLE}
          columns={inPatientColumns}
          dataSource={inPatientData}
          pagination={false}
          onRow={(record: any, rowIndex: any): any => {
            return {
              onClick: (event: any): any => { rowClick(event, record, rowIndex); },
            };
          }}
          locale={{
            emptyText: (
              isTblLoading ?
                <div className="full-skelton-in-list">
                  {blankArr.map((...params: any[]): any =>
                    <Skeleton
                      key={params[1]}
                      active={true}
                      paragraph={{ rows: 0 }}
                    />,
                  )}
                </div>
                : <Empty />
            ),
          }}
          onChange={handleTableChange}
        />
      </Form>
      {(inPatientDataCount > 0 || draftDataCount > 0) && <Pagination
        data-testid="pagination"
        showSizeChanger={false}
        onChange={pageChange}
        defaultCurrent={1}
        current={pageIndex}
        total={isDraftBtnClicked ? draftDataCount : inPatientDataCount}
        className="mt-md text-center"
      />}
    </div>
  </>;
};

export default List;
